import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

export const typeaheadFilter = (list) => (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(
      term =>
        term.length < 1
          ? []
          : list
              .filter(v => v.toLowerCasge().indexOf(term.toLowerCase()) > -1)
              .slice(0, 10)
    )
  );

export const resetForm = (fields, source) => {
  return fields.reduce((obj, field) => {
    obj[field.fieldName] = {
      value:
        field.type !== 'select'
          ? (source && source[field.fieldName]) || null
          : (source && source[field.fieldName]) || '',
      disabled: field.disabled
    };
    return obj;
  }, {});
};

export const resetMetadata = (fields, source) => {
  return fields.reduce((obj, field) => {
    obj[field.fieldName] = {
      value:
        field.type !== 'select'
          ? (source && source.metadata && source.metadata[field.fieldName]) ||
            null
          : (source && source.metadata && source.metadata[field.fieldName]) ||
            '',
      disabled: field.disabled
    };
    return obj;
  }, {});
};

export const initMetadata = (fields, source) => {
  return fields.reduce((obj, field) => {
    obj[field.fieldName] = [
      {
        value:
          field.type !== 'select'
            ? (source && source.metadata && source.metadata[field.fieldName]) ||
              null
            : (source && source.metadata && source.metadata[field.fieldName]) ||
              '',
        disabled: field.disabled
      }
    ];
    if (field.required) {
      obj[field.fieldName].push([Validators.required]);
    }
    return obj;
  }, {});
};

export const initForm = (fields, source) => {
  return fields.reduce((obj, field) => {
    obj[field.fieldName] = [
      {
        value:
          field.type !== 'select'
            ? (source && source[field.fieldName]) || null
            : (source && source[field.fieldName]) || '',
        disabled: field.disabled
      }
    ];
    if (field.required) {
      obj[field.fieldName].push(Validators.required);
    }
    return obj;
  }, {});
};
